import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import Register from './Components/Register';
import Dashboard from './Components/Dashboard';
import CreateJob from './Components/CreateJob';
import AdminSection from './Components/AdminSection';
import Report from './Components/Report';
import Jobs from './Components/Jobs';
import TestReport from './Components/TestReport';
import FailureReport from './Components/FailureReport';
import EditJob from './Components/EditJob';
import EditFailureReport from './Components/EditFailureReport';
import EditTestReport from './Components/EditTestReport';
import Notifications from './Components/Notifications';
import CreateRFQ from './Components/CreateRFQ';
import EditRFQ from './Components/EditRFQ'; // ← NEW
import ClockIn from './Components/ClockIn';
import CollectionAndDelivery from './Components/CollectionAndDelivery';
import EditCollectionAndDelivery from './Components/EditCollectionAndDelivery';
import Payroll from './Components/Payroll';
import AddProduct from './Components/AddProduct';
import EditProduct from './Components/EditProduct';

export default function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/CreateJob" element={<CreateJob />} />
        <Route path="/AdminSection" element={<AdminSection />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/Jobs" element={<Jobs />} />
        <Route path="/TestReport" element={<TestReport />} />
        <Route path="/FailureReport" element={<FailureReport />} />
        <Route path="/Notifications" element={<Notifications />} />
        <Route path="/CreateRFQ" element={<CreateRFQ />} />
        <Route path="/Payroll" element={<Payroll />} />
        <Route path="/AddProduct" element={<AddProduct />} />
        {/* Products */}
        <Route path="/products/edit/:id" element={<EditProduct />} /> {/* NEW: Edit Product route */}
        {/* Collection & Delivery */}
        <Route path="/CollectionAndDelivery" element={<CollectionAndDelivery />} />
        <Route path="/CollectionAndDelivery/edit/:id" element={<EditCollectionAndDelivery />} />
        {/* Edits */}
        <Route path="/jobs/edit/:id" element={<EditJob />} />
        <Route path="/failure/edit/:id" element={<EditFailureReport />} />
        <Route path="/test/edit/:id" element={<EditTestReport />} />
        <Route path="/rfq/edit/:id" element={<EditRFQ />} /> {/* NEW */}
        <Route path="/ClockIn" element={<ClockIn />} /> {/* ← NEW: Clock In route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
